import { render, staticRenderFns } from "./pls_sss_yc.vue?vue&type=template&id=b270555c&scoped=true"
import script from "./pls_sss_yc.vue?vue&type=script&lang=js"
export * from "./pls_sss_yc.vue?vue&type=script&lang=js"
import style0 from "./pls_sss_yc.vue?vue&type=style&index=0&id=b270555c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b270555c",
  null
  
)

export default component.exports